// Copyright (c) 2024 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import factoryDuplicatePinPlates from './factory-duplicate-pin-plates';
import hasSearchResults from '../../shared/reducers/has-search-results';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';

export default {
    factoryDuplicatePinPlate: combineReducers({
        busyCounter,
        facets,
        factoryDuplicatePinPlates,
        hasSearchResults,
        searchByDropDown,
        searchFilters,
        searchQueryString
    })
};



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/reducers/index.js